import { render, staticRenderFns } from "./ProductionCardResume.vue?vue&type=template&id=1aa34ede&scoped=true"
import script from "./ProductionCardResume.vue?vue&type=script&lang=js"
export * from "./ProductionCardResume.vue?vue&type=script&lang=js"
import style0 from "./ProductionCardResume.vue?vue&type=style&index=0&id=1aa34ede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa34ede",
  null
  
)

export default component.exports